import { nft } from './http.service';

export const apiNft = {
    /**
     * 登录NFT
     * */
    nftLogin(data) {
        return nft.post('/nft/v1/users/login', { data });
    },
}
